// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#OneSVG{position:relative;width:60%;height:100%;background-color:rgba(6,30,93,.5);box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
